var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-page',{attrs:{"event":_vm.event}})
}
var staticRenderFns = []

export { render, staticRenderFns }